import useDoRecentOrder from '@activities/MainActivity/components/RecentOrders/hooks/useDoRecentOrder';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import PinMapLine from '@icons/pin/PinMapLine';
import { RecentOrderRow } from '@models/order';
import { useFlow } from '@stackflow/react';

import styles from './styles.module.scss';

interface Props {
    recentOrder: RecentOrderRow;
}

function RecentOrder({ recentOrder }:Props) {
    const { push } = useFlow();
    const handleClick = useDoRecentOrder(recentOrder);
    const {
        orderNo, orderName, shopName, orderItems, paymentAmount,
    } = recentOrder;
    const optionSummary = orderItems?.[0]?.options
        .map((option) => `${option.optionName}(${option.qty}개)`)
        .join(', ');
    const thumbnailImage = orderItems?.[0]?.thumbNailImageUrl;
    return (
        <div className={styles.container} onClick={handleClick} >
            <Image src={thumbnailImage}
                alt='메뉴 이미지'
                width={80}
                height={80}
                className={styles.thumbnail}/>
            <Column className={styles.contents} spacing={6}>
                <Text className={styles.name}>{orderName}</Text>
                <Column spacing={2}>
                    <Row spacing={2}>
                        <PinMapLine color={colors.gray6} size={16} />
                        <Text color={colors.gray6} className={styles.shop}>
                            {shopName}
                        </Text>
                    </Row>
                    <Text className={styles.options}>
                        {optionSummary}
                    </Text>
                    <Row>
                        <Text size='lg'
                            color={colors.gray8}
                            fontWeight='bold'>
                            {paymentAmount.toLocaleString()}
                        </Text>
                        <Text className={styles.priceUnit}
                            color={colors.gray8} >
                            원
                        </Text>
                    </Row>
                </Column>
            </Column>
        </div>
    );
}

export default RecentOrder;
